import { useMemo } from 'react';

function Strand({ top = 80, bulbs = 24 }: { top?: number; bulbs?: number }) {
  const bulbNodes = new Array(bulbs).fill(0).map((_, i) => {
    const hue = [0, 30, 120, 200, 300][i % 5];
    const left = (i / bulbs) * 100;
    const delay = Math.random() * 2;
    return (
      <div
        key={i}
        className="light-bulb"
        style={{
          left: `${left}%`,
          animationDelay: `${delay}s`,
          ['--h' as string]: hue,
        }}
        aria-hidden
      />
    );
  });

  return (
    <div className="light-strand" style={{ top: `${top}px` }}>
      <div className="light-wire" />
      {bulbNodes}
    </div>
  );
}

export default function Lights({ intensity = 'med' }: { intensity?: string }) {
  const strands = useMemo(() => {
    const count = intensity === 'high' ? 3 : intensity === 'low' ? 1 : 2;
    const tops = count === 3 ? [72, 120, 168] : count === 2 ? [84, 140] : [96];
    return tops.map((t, i) => <Strand top={t} key={i} bulbs={24} />);
  }, [intensity]);

  return <div className="overlay-root">{strands}</div>;
}
